jQuery(function($){
    $.datepicker.regional['ru'] = {
        closeText: 'Закрыть',
        prevText: '&#x3C;Пред',
        nextText: 'След&#x3E;',
        currentText: 'Сегодня',
        monthNames: ['Январь','Февраль','Март','Апрель','Май','Июнь',
        'Июль','Август','Сентябрь','Октябрь','Ноябрь','Декабрь'],
        monthNamesShort: ['Янв','Фев','Мар','Апр','Май','Июн',
        'Июл','Авг','Сен','Окт','Ноя','Дек'],
        dayNames: ['воскресенье','понедельник','вторник','среда','четверг','пятница','суббота'],
        dayNamesShort: ['вск','пнд','втр','срд','чтв','птн','сбт'],
        dayNamesMin: ['Вс','Пн','Вт','Ср','Чт','Пт','Сб'],
        weekHeader: 'Нед',
        dateFormat: 'dd.mm.yy',
        firstDay: 1,
        isRTL: false,
        showMonthAfterYear: false,
        yearSuffix: ''
    };
    $.datepicker.setDefaults($.datepicker.regional['ru']);
    
    var inp_files = $('.ajax_claim input[type="file"]');
       $('.ajax_claim input[type="file"]').hide();
       inp_files.each(function(ind, el){
           $(el).closest('.field_line').append('<div class="file_box"><span class="file_name">Файл не выбран</span><span class="for_file">Выберите файл</span> </div>');
       });
});
function incube_ajax(block,data_type, action, params, success_func, error_func) {
    $.ajax({
        type: "POST",
        url: '/ajax.php?block='+block+'&action='+action+'&data_type='+data_type,
        data: params,
        dataType: data_type,
        success: success_func,
        error: error_func       
    });
}
function incube_file_ajax(block,data_type, action, params, success_func, error_func) {
    $.ajax({
        type: "POST",
        url: '/ajax.php?block='+block+'&action='+action+'&data_type='+data_type,
        data: params,
        dataType: data_type,
        processData: false,
        contentType: false,
        success: success_func,
        error: error_func       
    });
}

$(function(){        
    $('input.claim_date').datepicker({"changeMonth":true,"changeYear":true});
    $('input.claim_phone').inputmask("+7(999)999-99-99");
});

//Обработчик для вызова всплывающей формы.
//Пример: <a href="/" class="show_form" cid="1">Заказать звонок</a>
//cid - это id заявки
$(document).on('click', '.show_form', function(e) {
    e.preventDefault();
    e.stopPropagation();
    var cid = $(this).attr('cid');
    claim_form_open(cid);
});

$(document).on('submit',".ajax_form", function(e){
    e.preventDefault();
    incube_file_ajax('claim','json', 'send_form', new FormData($(this)[0]), claimform);
});
    
function claim_form_open(cid){
     $('.cf_ok').hide();
     $('.form_content').show();
     $('.claim_input[type="text"], .claim_input[type="email"]').val(' ');
     $('.claim_input').removeClass('inp_error');
     $('.cf_error').hide();
    $('input.claim_phone').inputmask({"mask": "+7 (999) 999-99-99", clearMaskOnLostFocus: false});
    $.fancybox.open({
        'href': '#'+$(".ajax_claim[cid='"+cid+"']").attr('id'), 
        'padding':0,
        'wrapCSS' : 'fform',
        scrolling: false,
        autoResize: true,
        fitToView: false,
        helpers:  {
                 overlay : {
                 locked : false
            }
        }
    });
}

/*
function claimform(data){
    var current_form = $('#ajax_claim_'+data.pid);
    if(data.flag=='ok'){
        current_form.find('.suc_text').empty();
        current_form.find('.suc_text').html(data.claim.descr);
        current_form.find('.cf_ok').fadeIn();
        current_form.find('.form_content').hide();
    }else{
        current_form.find('.err_text').empty();
        if (data.error[0]) {
            current_form.find('.err_text').html(data.error[0]);
            current_form.find('.claim_input').removeClass('inp_error');
            for (var key in data.error_fields) {
                $('.claim_input[name="id' + key + '"]').addClass('inp_error');
            }
        }
        if (data.error[1]) {
            current_form.find('.err_text').html(data.error[1]);
        }
        current_form.find('.cf_error').fadeIn();
    }  
}*/

function claimform(data){
    var current_claim = $('#ajax_claim_'+data.pid);
    if ($('.fancybox-container #ajax_claim_'+data.pid)["length"]){
        current_claim = $('.fancybox-container #ajax_claim_'+data.pid);
    }
    var claim_id = parseInt(data.claim.id);
    current_claim.find('.cf_error').hide();
    current_claim.find('.cf_ok').hide();

    var current_form = current_claim.find('form');
    if(current_form[0].captcha)
        reload_captcha(data.pid);

    if(data.flag=='ok'){
        current_claim.find('.suc_text').empty();
        if(data.claim.descr!='') {
            current_claim.find('.suc_text').html(data.claim.descr);
        }
        else{
            current_claim.find('.suc_text').html('Заявка успешно отправлена');
        }
        current_claim.find('.cf_ok').show();
        current_claim.find('.cf_form').hide();
    }else{
        current_claim.find('.err_text').empty();
        current_claim.find('.captcha_input').removeClass('is-invalid');
        if (data.error[0]) {
            current_claim.find('.claim_input').removeClass('is-invalid');
            for (var key in data.error_fields) {
                $('.claim_input[name="id' + key + '"]').addClass('is-invalid');
            }
            var error_s = '';
            for (var key in data.error) {
                error_s+='<div>'+data.error[key]+'</div>';
            }
            current_claim.find('.err_text').html(error_s);
        }
        if (data.error_captcha) {
            current_claim.find('.captcha_input').addClass('is-invalid');
        }
        current_claim.find('.cf_error').show();
    }  
}

function reload_captcha_in_form(form){
    var random_number = getRandomInt(1000000, 10000000);
    form.rand.value = random_number;
    $(form).find('.captcha').attr('src','/captcha.php?rand='+random_number);
}

function reload_captcha(pid){
    var random_number = getRandomInt(1000000, 10000000);
    $('#rand-'+pid).val(random_number);
    $('#captcha-'+pid).attr('src','/captcha.php?rand='+random_number);
}

//Случайное целое.
function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min)) + min;
}


$(document).on('submit',".voting_form", function(e){
    e.preventDefault();
    incube_ajax('voting','json', 'send_form', $(this).serializeArray(), votingform);
});
    
function votingform(data){
    if(data.err){
       $('#voting_block_'+data.voting_id+ ' .var_answers').append('<div class="voting_err">Выберите ответ</div>'); 
    }else{
       $('#voting_block_'+data.voting_id).html(data.html); 
    }
}    

function create_map(wrap_id, x, y, text) {
    ymaps.ready(function() {
        var myMap = new ymaps.Map(wrap_id, {
            center: [x, y],
            zoom: 16,
            controls: []
        });
        myMap.behaviors.disable('scrollZoom');
        var myPlacemark = new ymaps.Placemark(myMap.getCenter(), {
            balloonContentBody: [
                '<address>',
                text,
                '</address>'
            ].join('')
        }, {
            preset: 'islands#redDotIcon'
        });
        myMap.geoObjects.add(myPlacemark);
    });
}

$(document).on('click', '.copy-btn', function(){
    if(!this.dataset.target) return;
    let target_elem = document.getElementById(this.dataset.target);
    if(!target_elem) return;
    navigator.clipboard.writeText(target_elem.textContent)
})